const getters = {
    token: state => state.user.token,
    userId: state => state.user.userId,
    username: state => state.user.username,
    user: state => state.user,
    uploadUrl: () => process.env.VUE_APP_BASE_UPLOAD_URL,
    docUrl: () => process.env.VUE_APP_BASE_DOC_URL,
    email: () => process.env.VUE_APP_EMAIL
}
export default getters